import {
  AUTH_BOOTSTRAP_PHASES,
  bootstrapAuthenticatedSession,
} from "./sessionBootstrapOrchestrator";
import { AccountExpiredError } from "./authBootstrapService";

export const AUTH_RESTORATION_RESULTS = {
  READY: "ready",
  RETRY: "retry",
  // Returned when the API explicitly rejects the account due to expiration_date.
  // Callers must not retry and must surface a clear error to the user.
  ACCOUNT_EXPIRED: "account_expired",
};

export const bootstrapIdentityRestoration = async ({
  userManager,
  forgeRockUserData,
}) => {
  try {
    await bootstrapAuthenticatedSession({
      phase: AUTH_BOOTSTRAP_PHASES.IDENTITY,
      userManager,
      forgeRockUserData,
    });

    return {
      status: AUTH_RESTORATION_RESULTS.READY,
    };
  } catch (error) {
    if (error instanceof AccountExpiredError) {
      return { status: AUTH_RESTORATION_RESULTS.ACCOUNT_EXPIRED };
    }
    console.error("Identity bootstrap failed during auth restoration.", error);
    return {
      status: AUTH_RESTORATION_RESULTS.RETRY,
      error,
    };
  }
};
